import Dashboard from 'CustomModules/SelfService/pages/Dashboard/Dashboard'
import Atributos from 'CustomModules/SelfService/pages/Dashboard/Atributos'

export const Routes = [
  {
    path: '/',
    name: 'Self Service Dashboard',
    component: Dashboard
  },
  {
    path: 'atributos_ss',
    name: 'Atribuntos',
    component: Atributos
  }
]



// WEBPACK FOOTER //
// ./src/customization/SelfService/routes.js